import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  fireBulkConfirmNoThanksClicked,
  fireBulkConfirmPopupViewed,
  fireBulkConfirmReviewClicked,
} from '~/posthogs/events';
import AnimatedCheckCircle from '../../shared/AnimatedCheckCircle';
import ConfirmPopup from '../../shared/ConfirmPopup';

export const ConfirmCandidateAnotherJobPopup = ({
  show,
  candidate,
  officeId,
  job,
  hasPendingJobs,
  onClose,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (show && candidate?.id) {
      fireBulkConfirmPopupViewed({ candidateId: candidate.id });
    }
  }, [show, candidate?.id]);

  if (!show || !job || !candidate) {
    return null;
  }

  return (
    <ConfirmPopup
      Icon={() => (
        <div style={{ marginBottom: 20 }}>
          <AnimatedCheckCircle />
        </div>
      )}
      title={`Candidate Confirmed for ${job?.local_date}!`}
      description={
        <span>
          {candidate?.full_name} has also applied to another shift at your office. Would you like to
          review their application?
        </span>
      }
      rightButtonAction={() => {
        fireBulkConfirmReviewClicked({ candidateId: candidate?.id });
        navigate(`/offices/${officeId}/candidates/${candidate?.id}/jobs`);
        onClose();
      }}
      rightButtonText="Review"
      leftButtonText="No Thanks"
      leftButtonAction={() => {
        fireBulkConfirmNoThanksClicked({ candidateId: candidate?.id });
        onClose();
        navigate(`/dashboard/jobs/${hasPendingJobs ? 'pending' : 'scheduled'}`);
      }}
    />
  );
};
